import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Zap, Check } from "lucide-react";

const PLANS = [
  {
    key: "starter",
    label: "Pro",
    price: "£9.99",
    highlights: ["Up to 3 projects", "Up to 10 members", "Gantt & sprints", "Full invoicing"],
  },
  {
    key: "professional",
    label: "Business",
    price: "£24.99",
    highlights: ["Unlimited projects", "Unlimited members", "CRM & compliance", "AI Co-Pilot"],
    recommended: true,
  },
];

export default function UpgradeModal({ open, onClose, reason }) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#0d1117] border border-[#1F2937] text-white max-w-lg p-0 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-br from-[#002FA7]/30 to-[#00F5D4]/10 px-6 pt-8 pb-6 border-b border-[#1F2937]">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-[#002FA7] flex items-center justify-center">
              <Zap className="w-4 h-4 text-white" />
            </div>
            <span className="text-xs font-mono uppercase tracking-[0.2em] text-[#00F5D4]">Upgrade required</span>
          </div>
          <DialogTitle className="text-xl font-bold text-white mb-2">
            You've hit your plan limit
          </DialogTitle>
          {reason && (
            <p className="text-sm text-slate-400 leading-relaxed">{reason}</p>
          )}
        </div>

        {/* Plan cards */}
        <div className="px-6 py-5 grid grid-cols-2 gap-3">
          {PLANS.map((plan) => (
            <div
              key={plan.key}
              className={`rounded-xl border p-4 relative ${
                plan.recommended
                  ? "border-[#00F5D4] bg-[#00F5D4]/5"
                  : "border-[#374151] bg-[#111827]"
              }`}
            >
              {plan.recommended && (
                <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 text-[10px] font-bold bg-[#00F5D4] text-[#030712] px-2 py-0.5 rounded-full uppercase tracking-wider">
                  Most popular
                </span>
              )}
              <div className="mb-1 text-sm font-bold text-white">{plan.label}</div>
              <div className="text-2xl font-black text-white mb-3">
                {plan.price}<span className="text-sm font-normal text-slate-400">/mo</span>
              </div>
              <ul className="space-y-1.5">
                {plan.highlights.map((h) => (
                  <li key={h} className="flex items-start gap-1.5 text-xs text-slate-300">
                    <Check className="w-3 h-3 text-[#00F5D4] mt-0.5 flex-shrink-0" />
                    {h}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="px-6 pb-6 flex flex-col gap-2">
          <Button
            className="w-full bg-[#002FA7] hover:bg-[#002480] text-white font-semibold h-10"
            onClick={() => { onClose(); navigate("/pricing"); }}
            data-testid="upgrade-modal-cta"
          >
            View plans & upgrade
          </Button>
          <button
            onClick={onClose}
            className="text-xs text-slate-500 hover:text-slate-300 transition text-center py-1"
          >
            Maybe later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
